import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
  getPaymentMethod,
  getCurrency,
} from "adminApi/PaymentSetupApi/PaymentSetup";
import feilds from "../json/PaymentSetupFeilds.json";
import { validateForm } from "utils/validation";
import { PaymentSetupValidationRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditPaymentSetupForm from "./Componates/EditPaymentSetupForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";

const EditPaymentSetup = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = feilds;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, PaymentSetupValidationRules);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  //Get Payment Method
  const { data: PaymentMethodOptions, loading: loadingPaymentMethod } = useFetchAllData(getPaymentMethod);

  //Get Currency
  const { data: CurrencyOptions, loading: loadingCurrency } = useFetchAllData(getCurrency);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, PaymentSetupValidationRules)
      setErrors(err)
      return err
    },
    () => {
      return navigate(-1)
    },
    "Payment Setup updated successfully"
  );

  console.log("PaymentMethodOptions", PaymentMethodOptions);

  return (

    <>
      {(loadingFetch || loadingSubmit || loadingPaymentMethod || loadingCurrency) && <Spinner isSpinner={true} />}
      <EditPaymentSetupForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update"
        PaymentMethodOptions={PaymentMethodOptions}
        CurrencyOptions={CurrencyOptions}
      />
    </>
  );
};

export default EditPaymentSetup;
